.scroll-to-top {
  cursor: pointer;
  position: fixed;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  z-index: 54;
}

.scroll-to-top.visible {
  opacity: 1;
}
